import { render, staticRenderFns } from "./tabs-head.vue?vue&type=template&id=77c339eb&scoped=true&"
import script from "./tabs-head.vue?vue&type=script&lang=js&"
export * from "./tabs-head.vue?vue&type=script&lang=js&"
import style0 from "./tabs-head.vue?vue&type=style&index=0&id=77c339eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c339eb",
  null
  
)

export default component.exports